import React from 'react';
import Badge from '@components/ringil3/Badges/Badge';
import { formatVolume, isNotNullOrUndefined } from '@utils/utils';
import { SecuredConfig, useSecuredDecoration } from '@components/security/securedDecoration';

interface ComponentProps {
  volume: number;
  dataTestId?: string;
  secured?: SecuredConfig;
}

const VolumeBadge: React.FC<ComponentProps> = ({ volume, dataTestId, secured }) => {
  const { decorate } = useSecuredDecoration(secured);
  return <>{decorate(isNotNullOrUndefined(volume) && <Badge filled={false} value={formatVolume(volume)} highlightedValue={false} dataTestId={dataTestId}></Badge>)}</>;
};

export default VolumeBadge;
